import { StyledHorizontalSpacer } from "./style";

const HorizontalSpacer = (props: any) => {
    return(
        <StyledHorizontalSpacer {...props}></StyledHorizontalSpacer>
    );
}

export default HorizontalSpacer;